import { useEffect, useState } from "react";

const BREAKPOINT = 900;

// A plain width>=900 check puts every iPad except the 12.9" Pro into the
// phone layout the instant it's held in portrait — every iPad's portrait
// width (mini 768, standard/Air 810-820, Pro 11" 834) sits under 900, even
// though it's a full tablet, not a phone. No real phone (portrait or
// landscape) reaches 740px wide, so requiring both a lower width floor AND
// a tall portrait-shaped viewport (height >= 900) picks up every iPad in
// portrait without reclassifying any actual phone.
function computeIsDesktop(): boolean {
  if (typeof window === "undefined") return true;
  const w = window.innerWidth;
  const h = window.innerHeight;
  return w >= BREAKPOINT || (w >= 740 && h >= 900);
}

/** Mirrors the mockup's own `state.w >= 900` desktop/mobile split — widened to also cover a tablet held in portrait (see computeIsDesktop's doc). */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(computeIsDesktop);

  useEffect(() => {
    const onResize = () => setIsDesktop(computeIsDesktop());
    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  return isDesktop;
}
